export default __webpack_public_path__ + "static/media/e-internet.25deb2ca.png";